import cohortApi from './api';
import cohortsLayout from './layout';
import cohortToasts from './toasts';
import cohortProfileApi from '../profile/sagas/api';
import cohortSharingApi from '../sharing/sagas/api';
import cohortSharingLayout from '../sharing/sagas/layout';
import systemCohortsApi from '../system/sagas/api';
import cohortVisualisationApi from '../visualisations/sagas/api';

export default [
  cohortApi(),
  cohortsLayout(),
  cohortToasts(),
  cohortProfileApi(),
  cohortSharingApi(),
  cohortSharingLayout(),
  systemCohortsApi(),
  cohortVisualisationApi(),
];
